module.exports = __webpack_public_path__ + "static/media/twitter-x.52469628.svg";